import { useCallback, useState } from 'react'
import { showAlert } from '../../utility/SweetAlert'
import ApiService from '../../services/ApiService'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const InteractorProductList = () => {
  const { t } = useTranslation()
  const [productListData, setProductListData] = useState({})
  const [productLoading, setProductLoading] = useState(true)
  const [productPages, setProductPages] = useState({
    currentPage: 1,
    limitProduct: 0,
    totalPages: 1,
    totalItem: 0,
  })
  const { seller } = useSelector((state) => state.seller)

  const productList = useCallback(
    (payload, setLoading = () => {}) => {
      let payloadRequest = {
        ...payload,
        keywords: {
          ...payload.keywords,
          store_uid: seller.uid,
          source: 'SELLER',
        },
      }
      setLoading(true)
      ApiService.jsonRequest('/product-item/search', payloadRequest, (response) => {
        setLoading(false)
        if (response.status_code === 200) {
          const { pages } = response.data
          setProductPages({
            currentPage: pages.page,
            limitProduct: pages.limit,
            totalPages: pages.total_pages,
            totalItem: pages.total_items,
          })
          setProductListData(response.data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
      })
    },
    [seller.uid, t],
  )

  const productView = useCallback(
    (uid, setLoading = () => {}) => {
      const payload = {
        uid,
      }
      setLoading(true)
      ApiService.jsonRequest('/product-item/view', payload, (response) => {
        setLoading(false)
        if (response.status_code === 200) {
          setProductListData(response.data)
          setProductLoading(false)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
      })
      return fetch
    },
    [t],
  )

  return {
    productListData,
    productList,
    productView,
    productPages,
    setProductPages,
    productLoading,
  }
}

export default InteractorProductList
